import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EjemploLoaderComponent } from './ejemplo-loader/ejemplo-loader.component';
import { EjemploTablasComponent } from './ejemplo-tablas/ejemplo-tablas.component';
import { EjemploAlertComponent } from './ejemplo-alert/ejemplo-alert.component';
import { EjemploColoresComponent } from './ejemplo-colores/ejemplo-colores.component';
import { EjemploBotonesComponent } from './ejemplo-botones/ejemplo-botones.component';
import { AppModule } from '../app.module';
import { CustomComponentsModule } from '../commons/custom-components.module';



@NgModule({
  declarations: [
    EjemploLoaderComponent,
    EjemploTablasComponent,
    EjemploAlertComponent,
    EjemploColoresComponent,
    EjemploBotonesComponent,
  ],
  imports: [
    CustomComponentsModule
  ],
  exports: [
    EjemploLoaderComponent,
    EjemploTablasComponent,
    EjemploAlertComponent,
    EjemploColoresComponent,
    EjemploBotonesComponent,
  ]
})
export class EjemplosModule { }
